var _defs, _rect, _rect2, _rect3, _ellipse, _ellipse2, _ellipse3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _ellipse4, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenchmarking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_web_search_re_efla",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 627,
    height: 513.088,
    viewBox: "0 0 627 513.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#363280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98788e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_161",
    "data-name": "Rect\\xE1ngulo 161",
    width: 568.968,
    height: 378.765,
    transform: "translate(0.243 0.335)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_162",
    "data-name": "Rect\\xE1ngulo 162",
    width: 536.429,
    height: 308.851,
    transform: "translate(16.512 47.842)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_163",
    "data-name": "Rect\\xE1ngulo 163",
    width: 568.968,
    height: 25.125,
    fill: "#ef7a90"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_15",
    "data-name": "Elipse 15",
    cx: 4.48,
    cy: 4.657,
    rx: 4.48,
    ry: 4.657,
    transform: "translate(13.483 8.189)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_16",
    "data-name": "Elipse 16",
    cx: 4.48,
    cy: 4.657,
    rx: 4.48,
    ry: 4.657,
    transform: "translate(30.488 8.189)",
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_17",
    "data-name": "Elipse 17",
    cx: 4.48,
    cy: 4.657,
    rx: 4.48,
    ry: 4.657,
    transform: "translate(47.493 8.189)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_164",
    "data-name": "Rect\\xE1ngulo 164",
    width: 137.837,
    height: 244.759,
    transform: "translate(65.254 79.887)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_165",
    "data-name": "Rect\\xE1ngulo 165",
    width: 114.864,
    height: 67.373,
    transform: "translate(226.885 79.887)",
    fill: "#ef7a90"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_166",
    "data-name": "Rect\\xE1ngulo 166",
    width: 114.864,
    height: 72.49,
    transform: "translate(226.885 166.022)",
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_167",
    "data-name": "Rect\\xE1ngulo 167",
    width: 114.864,
    height: 67.373,
    transform: "translate(226.885 257.274)",
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_168",
    "data-name": "Rect\\xE1ngulo 168",
    width: 137.837,
    height: 106.665,
    transform: "translate(366.362 79.887)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_169",
    "data-name": "Rect\\xE1ngulo 169",
    width: 137.837,
    height: 106.665,
    transform: "translate(366.362 217.982)",
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_409",
    "data-name": "Trazado 409",
    d: "M755.712,377.377V354.414c0-16.994,13.254-30.771,29.6-30.771s29.6,13.777,29.6,30.771v22.963a4.062,4.062,0,0,1-3.976,4.134H759.689A4.062,4.062,0,0,1,755.712,377.377Z",
    transform: "translate(-304.612 -183.162)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_410",
    "data-name": "Trazado 410",
    d: "M590.019,533.073l-10.442,3-16.115-40.432,15.411-4.433Z",
    transform: "translate(-65.542 -40.017)",
    fill: "#faf8f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_411",
    "data-name": "Trazado 411",
    d: "M13-.344,33.952-.556l-.133,13.637-34.145.345h0A13.747,13.747,0,0,1,13-.344Z",
    transform: "translate(493.317 498.899) rotate(-15.47)",
    fill: "#221e1d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_412",
    "data-name": "Trazado 412",
    d: "M468.224,542.023H457.39l-5.155-43.436h15.99Z",
    transform: "translate(-52.604 -40.618)",
    fill: "#faf8f8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_413",
    "data-name": "Trazado 413",
    d: "M447.579,542.372h20.894v13.674H434.424A13.422,13.422,0,0,1,447.579,542.372Z",
    transform: "translate(-50.532 -44.185)",
    fill: "#221e1d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_414",
    "data-name": "Trazado 414",
    d: "M700.543,450.983a8.8,8.8,0,0,0,6.612,3.722,8.712,8.712,0,0,0,6.99-2.879l28.8,13.464-2.62-16.838-26.947-10.2a8.683,8.683,0,0,0-11.859.442,9.556,9.556,0,0,0-.975,12.293Z",
    transform: "translate(-297.987 -192.326)",
    fill: "#faf8f8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_415",
    "data-name": "Trazado 415",
    d: "M762.544,551.924c-9.048,0-18.415-1.4-26.288-5.568a34.98,34.98,0,0,1-17.416-21.646c-4.1-13.5,1.07-26.766,6.072-39.593,3.1-7.949,6.027-15.456,6.787-22.857l.265-2.627c1.183-11.8,2.2-21.993,7.862-25.816,2.932-1.981,6.875-2.094,12.054-.346L800.521,449.9l-1.788,95.978-.3.1C798.183,546.066,781.036,551.924,762.544,551.924Z",
    transform: "translate(-300.151 -192.009)",
    fill: "#221e1d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_416",
    "data-name": "Trazado 416",
    d: "M753.54,400.589S777.4,393.241,795.957,396c0,0-10.6,60.623-7.07,80.831s-61.415,7.808-48.16-11.482l4.418-22.963s-8.837-9.185-.884-20.208Z",
    transform: "translate(-302.662 -189.006)",
    fill: "url(#linear-gradient-2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_417",
    "data-name": "Trazado 417",
    d: "M738.311,547.268l-29.406-5.731,10.266-82.123c.691-2.293,16.594-54.325,23.817-57.14a119.623,119.623,0,0,1,16.053-4.636l1.046-.218-5.9,9.193-23.474,58.469Z",
    transform: "translate(-299.168 -189.173)",
    fill: "#221e1d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_418",
    "data-name": "Trazado 418",
    d: "M719.842,686.035l-37.994-6.582,21.321-90.5L734.9,465.2l.313,2.2c.025.164,2.989,16.331,46.968,9.157l.387-.063.107.392L835.827,672.1l-43.292,7.5L753.05,537.168Z",
    transform: "translate(-296.021 -194.694)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_419",
    "data-name": "Trazado 419",
    d: "M784.436,562.378l.024-.695c.026-.771,2.64-77.5,1.767-108.357-.876-30.963,8.768-57.777,8.865-58.044l.078-.215.214-.064c12.477-3.705,23.3,7.353,23.41,7.465l.152.158L815.392,433.1l15.214,110.814Z",
    transform: "translate(-307.953 -188.914)",
    fill: "#221e1d"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_18",
    "data-name": "Elipse 18",
    cx: 21.704,
    cy: 22.56,
    rx: 21.704,
    ry: 22.56,
    transform: "translate(452.916 152.693)",
    fill: "#faf8f8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_420",
    "data-name": "Trazado 420",
    d: "M747.787,356.984c.015-13.437,10.491-24.326,23.417-24.341h4.419c12.927.015,23.4,10.9,23.417,24.341v.459H789.7l-3.185-9.27-.637,9.27h-4.826l-1.607-4.677-.321,4.677h-31.34Z",
    transform: "translate(-303.691 -183.896)",
    fill: "url(#linear-gradient)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_421",
    "data-name": "Trazado 421",
    d: "M779.81,385.73a4.207,4.207,0,0,1-.311-4.324c4.683-9.257,11.238-26.362,2.537-36.911l-.625-.758h25.262v39.424l-22.949,4.209a3.872,3.872,0,0,1-3.913-1.64Z",
    transform: "translate(-307.326 -184.799)",
    fill: "url(#linear-gradient-4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_422",
    "data-name": "Trazado 422",
    d: "M638.98,209.656c-49.27-43.215-122.655-37.933-165.725,11.927s-40.248,126.265,6.373,172.546,120.179,45.7,166.117-1.315L792.1,521.178a10.709,10.709,0,0,0,15.495-1.349,11.742,11.742,0,0,0-1.3-16.106l-.016-.014L659.925,375.346c35.235-52.564,26.158-124.372-20.945-165.69Zm-9.435,153.329c-31.838,39.22-88.235,44.187-125.967,11.093s-42.51-91.716-10.672-130.936,88.235-44.186,125.967-11.093h0c37.732,33.094,42.51,91.715,10.672,130.935Z",
    transform: "translate(-268.205 -171.495)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_423",
    "data-name": "Trazado 423",
    d: "M506.166,380.176c-35.558-31.19-42.155-85.515-15.169-124.911q-2.564,2.684-4.957,5.621c-31.838,39.22-27.06,97.841,10.672,130.935s94.129,28.127,125.967-11.093q2.387-2.942,4.5-6.025c-32.821,34.278-85.449,36.658-121.009,5.472Z",
    transform: "translate(-270.793 -177.592)",
    fill: "#221e1d",
    opacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_424",
    "data-name": "Trazado 424",
    d: "M789.31,492.722a8.619,8.619,0,0,0,7.373-1.53,9.337,9.337,0,0,0,3.605-6.859l30.428-8.779-12.369-11.209-27,10.055a9.067,9.067,0,0,0-8.847,8.219A9.268,9.268,0,0,0,789.31,492.722Z",
    transform: "translate(-307.722 -194.625)",
    fill: "#faf8f8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M804.283,483.073l-1.852-18.284,25.417-14.576-16.571-20.851,2.7-23.422,6.733-3,.209.28c3.175,4.244,31.022,41.592,31.022,46.209,0,4.742-5.327,18.668-12.616,22.456-7.03,3.654-33.43,10.756-34.551,11.057Z",
    transform: "translate(-310.047 -189.622)",
    fill: "#221e1d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M909.332,729.134H572.65a.919.919,0,0,1,0-1.837H909.332a.919.919,0,0,1,0,1.837Z",
    transform: "translate(-283.216 -216.046)",
    fill: "#ccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarking);
export default __webpack_public_path__ + "static/media/benchmarking.8a0e4b1acdc27aa6d8ba3700be649aeb.svg";
export { ForwardRef as ReactComponent };